import { NavLink, useLocation } from 'react-router-dom';
// export const url="http://localhost:4000"
export const url="https://payloadcms.piro.my.id"
export const urlCloudFunction="https://us-central1-doc-basic.cloudfunctions.net/dashuserbalance2gen/v1/users-by-dash "
export const urlCloudFunctionSanta="https://us-central1-santaclaus-bfa10.cloudfunctions.net/dashuserbalance2gen/v1/users-by-dash "
export const urlDashboard="https://us-central1-doc-basic.cloudfunctions.net/dashboard2gen/v1"
export const urlDashboardSanta="https://us-central1-santaclaus-bfa10.cloudfunctions.net/dashboard2gen/v1"

export const LinkWithQuery = ({ children, to, ...props }) => {
  const { search } = useLocation();

  return (
    <NavLink to={to + search} {...props}>
      {children}
    </NavLink>
  );
};